import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'imagesloaded';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    const $nav = $('.js-nav-mobile');
    const $burgerButton = $('.js-burger');

    const animateHeader = () => {
      $burgerButton.toggleClass('active');
      $nav.addClass('transition');
      $nav.toggleClass('active');
      $('html').toggleClass('noscroll');
    };

    $('.js-slide__content').imagesLoaded(
      {
        background: true,
      },
      function () {
        $('.js-slide__content').addClass('active');
        $('.js-loading').addClass('active');
      }
    );
    if ($burgerButton.length > 0) {
      $burgerButton.on('click', function () {
        animateHeader();
      });
    }

    if ($('.js-share__item__action').length > 0) {
      $('.js-share__item__action').on('click', function (e) {
        e.preventDefault();
        window.open($(this).attr('href'), 'title', 'width=600, height=500');
      });
    }

    /* Text + gallery carousels. A page can hold more than one. */
    document.querySelectorAll('.js-textcarousel').forEach(function (element) {
      const container = element.closest('.textcarousel');
      const pagination = container
        ? container.querySelector('.js-textcarousel__pagination')
        : null;

      const textCarousel = new Swiper(element, {
        modules: [Pagination],
        slidesPerView: 1,
        autoHeight: true,
        pagination: pagination ? { el: pagination, clickable: true } : false,
      });

      /* Recalculate once the gallery images have dimensions. */
      $(element).imagesLoaded(function () {
        textCarousel.update();
      });
    });

    if ($('.js-homeHero').length > 0) {
      const heroCarousel = new Swiper('.js-homeHero', {
        modules: [Autoplay],
        slidesPerView: 1,
        /* Drives the slide content animation in _trumps.homeHero.scss. */
        slideActiveClass: 'is-selected',
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
        },
      });

      $('.js-homeHero__carousel__action').on('click', function (e) {
        e.preventDefault();
        const index = $(this).data('jump');
        heroCarousel.slideTo(index);
      });

      heroCarousel.on('slideChange', function () {
        const currentIndex = heroCarousel.activeIndex + 1;
        $('.js-homeHero__carousel__nav__item').removeClass('active');
        $(
          `.js-homeHero__carousel__nav__item:nth-child(${currentIndex})`
        ).addClass('active');
      });
    }
  },
};
